import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=2a181542&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
import style0 from "./styles/save.scss?vue&type=style&index=0&id=2a181542&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a181542",
  null
  
)

export default component.exports